import environment from "@menu-environment";
import BaseService from "./base.service";
import { UrlBuilder } from "@lib-shared/lib";
import { Settings } from "@menu/core/types";
import { ISampleDataProvider } from "./data/sample-data-provider.interface";

const useSampleData = !environment.production && environment.menu.useSampleData;

let sampleDataProvider: ISampleDataProvider | undefined = undefined;

class SettingsService extends BaseService {
    constructor() {
        super();
        this.setBaseUrl("umbraco/api/Configuration/");
    }

    async getSettings(countryCode: string, currentPage: string) {
        if (useSampleData) {
            sampleDataProvider = (await import("@menu-sample-data-provider")).default;
            return sampleDataProvider.getSettings(countryCode);
        }

        const urlBuilder = new UrlBuilder("RetrieveSettings")
            .appendParam("countryCode", countryCode)
            .appendParam("currentPageUrl", currentPage)
            .appendParam("useCamelCase", "true")
            .appendParam("version", "2");

        const response = await this.createPromiseRequest(urlBuilder.toString()).get<Settings>();

        return response.data;
    }
}

export default SettingsService;